module.exports = __webpack_public_path__ + "static/images/americanexpress-fb48e526.png";